import { useContext, useMemo } from 'react';
import { usePortfolioData } from '../components/data/PortfolioData';
import { PlantDataContext } from '../components/data/PlantData';
import {
  createPortfolioDateFormatter,
  resolvePortfolioTimeZone,
} from './dateTime';

export function usePortfolioDateFormatter(options = {}) {
  const { portfolioName } = options;
  const plantContext = useContext(PlantDataContext);
  const { data: portfolios } = usePortfolioData();

  const timeZone = useMemo(() => {
    if (plantContext?.plant?.timezone) {
      return plantContext.plant.timezone;
    }

    if (portfolioName) {
      return resolvePortfolioTimeZone(portfolios, portfolioName);
    }

    return resolvePortfolioTimeZone(portfolios);
  }, [plantContext?.plant?.timezone, portfolioName, portfolios]);

  return useMemo(() => createPortfolioDateFormatter(timeZone), [timeZone]);
}
